const SvgIconCheck = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" fill="none">
    <path
      d="M3.4375 10.1045L7.8125 14.4795L16.5625 5.10449"
      stroke="#514B4D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgIconCheck;
